import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
interface LicenseModalTabTwoProps {
  licenseDetailsAll: any; // Use the appropriate type instead of `any[]` if known
}

const LicenseModalTabTwo: React.FC<LicenseModalTabTwoProps> = ({ licenseDetailsAll }) => {
  console.log(licenseDetailsAll)

  return (
    <div> <TableContainer component={Paper}   sx={{ backgroundColor: "#03171f" }}>
    <Table  sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
      <TableHead>
        <TableRow style={{ borderBottom: "2px solid #313838" }}>
          <TableCell sx={{ color: '#fff' }}>Name</TableCell>
          {/* <TableCell sx={{ color: '#fff' }}>Type</TableCell> */}
          <TableCell sx={{ color: '#fff' }}>Hardware ID</TableCell>
          {/* <TableCell sx={{ color: '#fff' }}>Last Checked</TableCell> */}
          <TableCell sx={{ color: '#fff' }}>Status</TableCell>
          {/* <TableCell sx={{ color: '#fff' }}>Device Variables</TableCell> */}
          {/* <TableCell sx={{ color: '#fff' }}>Actions</TableCell> */}
        </TableRow>
      </TableHead>
      <TableBody>
        {licenseDetailsAll?.sites?.map((row:any, index:any) => (
          <TableRow key={index}>
            <TableCell sx={{ color: '#fff' }}>{row?.name}</TableCell>
            {/* <TableCell sx={{ color: '#fff' }}>{row.type}</TableCell> */}
            <TableCell sx={{ color: '#fff' }}>{row?.deviceid}</TableCell>
            {/* <TableCell sx={{ color: '#fff' }}>{row.lastChecked}</TableCell> */}
            <TableCell sx={{ color: '#fff' }}>{row?.status}</TableCell>
            {/* <TableCell sx={{ color: '#fff' }}>{row.deviceVariables}</TableCell>
            <TableCell sx={{ color: '#fff' }}>{row.actions}</TableCell> */}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer></div>
  )
}

export default LicenseModalTabTwo